import Box from '../../components/fela/Box';
import { FelaCSS } from '../../components/fela/flowtypes';
import { DroppedFile } from '../../components/file-uploader/types';

type Props = {
  dropped: DroppedFile;
  style: { progress: FelaCSS };
};

const UploadingProgress = ({ dropped, style }: Props) => (
  <div>
    <Box as="progress" style={style.progress} value={dropped.percents || 0} max="100">
      {dropped.status}
    </Box>
  </div>
);

export default UploadingProgress;
